import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from './../../../reusable/Spinner/Spinner';


export default class TableRow extends Component {
    static propTypes = {
        headerItems: PropTypes.array.isRequired,
        item: PropTypes.object
    }

    static defaultProps = {
        width: null
    }

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        let update = false;
        if (nextProps.item.updateFunc && nextProps.item.updateFunc.length) {
            nextProps.item.updateFunc.forEach(func => {
                if (func(this.props.item, nextProps.item)) {
                    update = true;
                }
            })
        } else {
            update = true;
        }
        return update;
    }

    render() {
        let cells = [], cellsId = [];
        const item = this.props.item;

        this.props.headerItems.forEach(headerItem => {
            if (headerItem.key !== "key") {
                cells.push(item[headerItem.key]);
                cellsId.push(headerItem.key);
            }
        })

        const cellsJsx = cells.map((cell, key) => key !== "key" ?
            <span className={`cell cell-${cellsId[key]}`} key={"cell_" + this.props.item.key + "_" + key}>{cell}</span> : null);

        return (
            <Spinner isLoading={item.object && item.object.busy} withAnimation key={this.props.item.key} className={'busy-row'}>
                <div className="row" key={"row_" + this.props.item.key}>
                    {cellsJsx}
                </div>
            </Spinner>
        );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/Components/TableRow.jsx